import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import css from './OfferToggle.module.css';
import {
  updateProfile,
  updateProfileInProgressSelector,
} from '../../../ProfileSettingsPage/ProfileSettingsPage.duck';
import { currentUserSelector } from '../../../../ducks/user.duck';
import { showErrorToast, showSuccessToast } from '../../../../util/toast';
import { getUserOfferAvailability } from '../../../../util/dataExtractor';

const OfferToggle = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(currentUserSelector);
  const updateInProgress = useSelector(updateProfileInProgressSelector);
  const isAvailableForOffers = getUserOfferAvailability(currentUser);

  const [isEnabled, setIsEnabled] = useState(isAvailableForOffers);

  const handleToggle = useCallback(async () => {
    const newValue = !isEnabled;

    // Optimistic UI update
    setIsEnabled(newValue);

    try {
      await dispatch(
        updateProfile({
          publicData: {
            isAvailableForOffers: newValue,
          },
        })
      );

      // showSuccessToast(
      //   <FormattedMessage
      //     id="OfferToggle.updateSuccess"
      //     defaultMessage="Offer preference updated successfully"
      //   />
      // );
    } catch (error) {
      // Revert optimistic update on error
      setIsEnabled(!newValue);

      showErrorToast(
        <FormattedMessage
          id="OfferToggle.updateError"
          defaultMessage="Failed to update offer preference. Please try again."
        />
      );
    }
  }, [isEnabled, dispatch]);

  const toggleClasses = `${css.toggleSwitch} ${isEnabled ? css.enabled : ''}`;

  return (
    <div className={css.offerToggleContainer}>
      <div className={css.toggleWrapper}>
        <label className={css.toggleLabel} htmlFor="offer-toggle">
          <span className={css.labelText}>
            <FormattedMessage id="OfferToggle.enableOfferHeading" defaultMessage="Enable Offers" />
          </span>
          <p className={css.description}>
            <FormattedMessage
              id="OfferToggle.enableOfferDescription"
              defaultMessage="Allow buyers to make offers on your products"
            />
          </p>
        </label>

        <button
          id="offer-toggle"
          type="button"
          role="switch"
          aria-checked={isEnabled}
          aria-label="Toggle offer availability"
          className={toggleClasses}
          onClick={handleToggle}
          disabled={updateInProgress}
        >
          <span className={css.toggleThumb} aria-hidden="true" />
        </button>
      </div>

      {updateInProgress && (
        <span className={css.updatingText} role="status" aria-live="polite">
          <FormattedMessage id="OfferToggle.updating" defaultMessage="Updating..." />
        </span>
      )}
    </div>
  );
};

export default OfferToggle;
